import analytics from "@/utils/analytics";
import { apiClient } from "./apiClient";
import { API_ENDPOINTS } from "../services/api";

export interface CardPaymentRequest {
  plan: number; // Plan name for card payments
  email?: string; // Email for card payments
}

export interface CryptoPaymentRequest {
  plan: number; // Plan name for card payments
  cryptoType: 'bitcoin' | 'ethereum' | 'litecoin' | 'other';
  email?: string;
  anonymous?: boolean; // Whether to process anonymously
  
}

export interface PaypalCreateOrderRequest {
  plan: number;
  email?: string;
  cart?: Array<{
    id: string;
    quantity: number;
  }>;
}

export interface PaypalCaptureOrderRequest {
  orderId: string;
}

export interface PaymentResponse {
  sessionId?: string; // For card payments
  url?: string; // For crypto payments
  plan?: string; // For card payments
}

export interface PaypalCreateOrderResponse {
  create_time: string;
  update_time: string;
  id: string;
  status: string;
}

export enum PaymentStatus {
  CREATED = 0,
  SAVED = 1,
  APPROVED = 2,
  VOIDED = 3,
  COMPLETED = 4,
  PAYERACTIONREQUIRED = 5,
  _Unknown = 6,
}

export interface PaypalCaptureOrderResponse {
  id: string;
  status: PaymentStatus;
  purchaseUnits: Array<{
    items: Array<{
      name: string;
      unitAmount: {
        currencyCode: string;
        value: string;
      };
      quantity: string;
    }>;
    payments: {
      captures: Array<{
        id: string;
        status: string;
        unitAmount: {
          currencyCode: string;
          value: string;
        };
      }>;
    };
  }>;
  details?: Array<{
    issue: string;
    description: string;
  }>;
  debug_id?: string;
}

export const paymentAPI = {
  
  processCryptoPayment: async (data: CryptoPaymentRequest) => {
    try {
      analytics.trackPaymentAttempt('crypto', data.plan);
      const response = await apiClient.post<PaymentResponse>(API_ENDPOINTS.PAYMENT_CRYPTO, data);
      if (response) {
        analytics.trackPaymentSuccess('crypto', data.plan);
      }
      return response;
    } catch (error) {
      analytics.trackPaymentFailed('crypto', error instanceof Error ? error.message : 'Unknown error');
      throw error;
    }
  },

  createPaypalOrder: async (data: CardPaymentRequest) => {
    try {
      analytics.trackPaymentAttempt('paypal', data.plan);
      const response = await apiClient.post<PaypalCreateOrderResponse>(API_ENDPOINTS.PAYMENT_PAYPAL, data);
      if (response) {
        analytics.trackPaymentSuccess('paypal', data.plan);
      }
      return response;
    } catch (error) {
      analytics.trackPaymentFailed('paypal', error instanceof Error ? error.message : 'Unknown error');
      throw error;
    }
  },

  capturePaypalOrder: async (orderId: string) => {
    try {
      const response = await apiClient.post<PaypalCaptureOrderResponse>(
        API_ENDPOINTS.PAYMENT_PAYPAL_CAPTURE.replace(":orderId", orderId),
        {}
      );
      return response;
    } catch (error) {
      analytics.trackPaymentFailed('paypal', error instanceof Error ? error.message : 'Unknown error');
      throw error;
    }
  },

  getPaymentHistory: () =>
    apiClient.get<PaymentResponse[]>(API_ENDPOINTS.PAYMENT_HISTORY),
};